import {
  DISPLAY_LABEL_CODE_NAMES,
  PICKUP_LABEL_CODE_NAMES,
  type DisplayLabelCode,
  type PickupLabelCode,
} from './displayLabelCode';

/**
 * 주문 목록 '주문상태' 검색 — 목록 상태 칸(displayLabelCode)과 같은 기준으로 거른다(BE `displayLabelCodes`,
 * order-service 74aab38). 종전엔 orders.order_status 로 걸러 "배송중 검색 → 상품준비중 표시"처럼 어긋났다.
 *
 * 선택지 = BE 가 실제로 도출하는 배송 24종 + 픽업 6종. 도출되지 않는 PG_CHECK(PG확인요망)만 뺀다 — 골라도 늘 0건이다.
 * QA-501 — order-service #83 의 orders.cancel_origin 으로 PAYMENT_STOPPED(카드/PG 미완료 120분 경과)·
 * CANCEL_SOLDOUT(이관 고도몰 c2)도 나오므로 선택지에 넣는다.
 */
export type OrderLabelCode = DisplayLabelCode | PickupLabelCode;

// QA-530 반려 3종(order #102)·신청 3종(order #104)은 BE 검색까지 반영돼 선택지에 둔다.
const UNREACHABLE: ReadonlySet<DisplayLabelCode> = new Set(['PG_CHECK']);

/**
 * QA-625 상태값 정리 — 주문상태 선택지에서 뺀다. 표시 이름은 그대로라 기존 줄은 계속 그 이름으로 보인다.
 * 반려 3종은 클레임 관리 처리상태로, 반품보류는 반품 환불 실패 시 클레임 관리에 계속 보인다.
 * 반송중(반품)은 0건이라 빼고 반송중(교환)을 [반송중] 하나로 둔다. 품절취소는 이관 데이터가 있어 유지.
 */
const RETIRED: ReadonlySet<OrderLabelCode> = new Set([
  'EXCHANGE_HOLD',
  'RETURN_REJECTED',
  'EXCHANGE_REJECTED',
  'REFUND_REJECTED',
  'RETURN_SHIPPING',
  'RETURN_HOLD',
  'PICKUP_READY',
  'PICKUP_IN_PROGRESS',
]);

/** 고도몰 흐름 순서(DISPLAY_LABEL_CODE_NAMES 선언 순) → 픽업. */
export const SEARCHABLE_LABEL_CODES: ReadonlyArray<OrderLabelCode> = [
  ...(Object.keys(DISPLAY_LABEL_CODE_NAMES) as DisplayLabelCode[]).filter((c) => !UNREACHABLE.has(c)),
  ...(Object.keys(PICKUP_LABEL_CODE_NAMES) as PickupLabelCode[]),
].filter((c) => !RETIRED.has(c));

const isPickup = (code: OrderLabelCode): code is PickupLabelCode => code.startsWith('PICKUP_');

/**
 * 선택지 라벨. QA-625 로 선택지엔 반송중(교환)만 남아 [반송중]으로 보인다. 반송중(반품)은 저장된 옛 필터용으로만 구분을 붙인다.
 * 픽업은 배송 라벨과 겹치지 않게 '픽업 ' 접두를 붙인다.
 */
export const searchLabelOf = (code: OrderLabelCode): string => {
  if (isPickup(code)) return `픽업 ${PICKUP_LABEL_CODE_NAMES[code]}`;
  if (code === 'RETURN_SHIPPING') return '반송중(반품)';
  return DISPLAY_LABEL_CODE_NAMES[code];
};
